var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"echart",style:({width:_vm.chartWidth,height: _vm.chartHeight+'px'}),attrs:{"id":_vm.chartid}})
}
var staticRenderFns = []

export { render, staticRenderFns }